import type { NotificationConfig } from '../models';

export function createNotificationConfig(
  config: Partial<NotificationConfig> & Pick<NotificationConfig, 'text'>
): NotificationConfig {
  return {
    timeout: 8000,
    color: 'default',
    needTranslate: true,
    translatePlaceholders: {},
    ...config
  } as NotificationConfig;
}
